<template>
  <div>
    <SearchResultsMainSkeleton
      v-show="showSkeletonLoader"
      :are-results-available="hits.length > 0"
    />
    <div
      v-show="!showSkeletonLoader"
      :data-insights-index="indexName"
    >
      <div
        class="result-list w-full flex flex-col gap-9"
      >
        <ProductGroupsSlider
          v-if="shouldShowProductGroupSlider"
          class="px-4 lg:px-0"
          :items="productGroupItems"
          :text-color="productGroupItemsTextColor"
          :background-color="productGroupItemsBackgroundColor"
        />
        <ais-hits v-slot="{ items }">
<div

          >
            <ProductListing
              v-if="hits.length > 0"
              :items="items"
              :list-type="listType"
              :query="query"
              :category-filter="categoryFilter"
              @product-listing-shown="(products) => $emit('product-listing-shown', products)"
            />
            <div
              v-else
              class="flex flex-col items-center px-5"
            >
              <NoResults
                class="mb-10 lg:mb-14"
                :search-term="query"
              />
              <div v-if="canShowContent"><RenderContent :content="departmentBlockContent" /></div>
            </div>
          </div>
</ais-hits>
        <div
          v-if="hits.length > 0"
          class="pagination w-full flex justify-center lg:justify-between items-center my-10 px-10"
        >
          <PaginationWrapper />
          <div class="pagination__hits-per-page hidden lg:flex lg:items-center">
            <div class="pagination__hits-per-page__label text-EXPONDO-grey text-sm mr-2">
              {{ $t('Showing') }}
            </div>
            <ais-hits-per-page
              :items="HITS_PER_PAGE_ITEMS"
              data-testid="searchPagePagination"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">

import {
  AisHitsPerPage,
  AisHits,
} from 'vue-instantsearch/vue3/es';

import type { ProductGroupsItemType } from '~~/types/cms/ProductGroupsItem';
import { HITS_PER_PAGE_ITEMS, TYPESENSE_LOADING_STATE, TYPESENSE_STALLED_STATE } from '~~/constants/typesense';
import { SEARCH_VIEW } from '~~/types/search/SearchView';
import { COMPONENTS } from '~~/constants/cms';
import { i18nToTypesenseMainIndex } from '~~/helpers/locales/i18nCurrentDetails';

export default defineComponent({
  name: 'SearchResultsInner',
  components: {

    AisHitsPerPage,

    AisHits,
  },
  props: {
    categoryFilter: {
      type: String,
      default: '',
    },
    hits: {
      type: Array,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    productGroupItems: {
      type: Array as PropType<Array<ProductGroupsItemType>>,
      default: () => [],
    },
    productGroupItemsTextColor: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    productGroupItemsBackgroundColor: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
  emits: ['product-listing-shown'],
  setup(props) {

    const i18n = useI18n();

    const {
      loadComponent: departmentBlockSearch,
      internalCmsContent: departmentBlockContent,
      canShowContent,
    } = useInternalCms(COMPONENTS.SHOP_BY_DEPARTMENT.SLUG);

    const showSkeletonLoader = computed(() => {

      const isPending = props.status === TYPESENSE_STALLED_STATE || props.status === TYPESENSE_LOADING_STATE;

      return isPending && props.hits.length === 0;

    });

    const listType = ref<string>(SEARCH_VIEW.Grid);

    onMounted(() => {

      departmentBlockSearch();

    });

    const shouldShowProductGroupSlider = computed(() => {

      return props.productGroupItems.length > 0;

    });

    return {
      indexName: i18nToTypesenseMainIndex(i18n),
      HITS_PER_PAGE_ITEMS,
      listType,
      departmentBlockContent,
      canShowContent,
      showSkeletonLoader,
      shouldShowProductGroupSlider,
    };

  },
});

</script>
